<template>
  <div class="create-campaign text-center px-md-4">
      <h1 class="action-title white--text">Ready to turn insights into action?</h1>
      <p>Create a native campaign today.</p>

      <v-btn class="mb-5 text-capitalize font-weight-bold"
             href="https://my.outbrain.com/login"
             color="secondary"
             target="_blank"
             x-large
             width="275"
             height="63">
          Get Started
      </v-btn>
  </div>
</template>
<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({})
  export default class CreateCampaign extends Vue {

    mounted (){
    }

  }

</script>

<style scoped lang="scss">
  .create-campaign {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      max-width: 654px;
      margin: 0 auto;
      color: white;

      .action-title{
          line-height: 1.3;
      }


  }
</style>
